import { ConfigService } from '@axo/config';

/** @usage `Currency.format(100)` */

export class Currency {
  private static formatter: Intl.NumberFormat;

  static format(amount: number): string {
    if (!Currency.formatter) {
      const locale = ConfigService.get('global').i18n.defaultLocale;
      const currency = ConfigService.get('global').currency;

      Currency.formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0,
      });
    }

    return Currency.formatter.format(amount);
  }
}
